var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenieAsk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 22,
    viewBox: "0 0 128 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    width: 95.329,
    height: 15.493,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-GenieAsk"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GenieAsk",
    clipPath: "url(#clip-GenieAsk)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178699",
    "data-name": "Group 178699",
    transform: "translate(-3431.331 388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(3463.465 -385)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M144.774,11.511l-5.548-.028-1.481,4.227-2.127-.011L140.989,1l2.169.011,5.224,14.752-2.148-.011-1.46-4.241ZM142.042,3.03s-.341,1.333-.594,2.083l-1.671,4.663,4.463.022-1.6-4.68c-.247-.752-.553-2.088-.553-2.088Z",
    transform: "translate(-74.264 -0.548)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M167.966,17.869a4.529,4.529,0,0,0,3.018,1.246c.876,0,1.754-.451,1.759-1.305.01-1.94-5.415-1.57-5.4-5.012.01-1.919,1.725-2.994,3.832-2.985A4.744,4.744,0,0,1,174.571,11l-.821,1.519a3.859,3.859,0,0,0-2.6-.951c-.876,0-1.733.366-1.738,1.284-.01,1.9,5.416,1.508,5.4,4.971-.009,1.752-1.517,3.058-3.832,3.047a5.676,5.676,0,0,1-4-1.564l.988-1.434Z",
    transform: "translate(-91.436 -5.373)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M190.735,1.217l2.024.01-.041,8.051,1.481.007,2.9-3.864,2.295.011-3.527,4.634v.041l3.871,5.88-2.357-.012L194.233,11l-1.522-.007-.024,4.964-2.024-.01.073-14.725Z",
    transform: "translate(-104.406 -0.667)",
    fill: "#ea9a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M43.43,9.285c3.038.015,4.66,2.234,4.646,5.025,0,.31-.067,1.012-.067,1.012l-7.276-.036a3,3,0,0,0,3.149,2.806,5.206,5.206,0,0,0,3.044-1.142l1,1.887a6.588,6.588,0,0,1-4.244,1.488,5.4,5.4,0,0,1-5.636-5.547A5.21,5.21,0,0,1,43.43,9.285Zm2,4.227a2.035,2.035,0,0,0-2.077-2.2,2.455,2.455,0,0,0-2.533,2.178l4.61.023Z",
    transform: "translate(-20.835 -5.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M66.574,9.654l2.522.013-.006,1.219a6.508,6.508,0,0,1-.045.723h.042a4.087,4.087,0,0,1,3.752-2.172c2.336.011,3.653,1.238,3.639,4.028l-.033,6.78-2.6-.013.031-6.242c.006-1.282-.32-2.151-1.664-2.158a2.909,2.909,0,0,0-2.842,2.136,4.433,4.433,0,0,0-.193,1.4l-.024,4.837L66.522,20.2Z",
    transform: "translate(-36.427 -5.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M97.041.4h.3a1.289,1.289,0,0,1-.013,2.578l-.3,0A1.289,1.289,0,1,1,97.041.4m-1.186,4.37,2.625.013-.052,10.542L95.8,15.315Z",
    transform: "translate(-52.43 -0.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M113.181,9.633c3.038.015,4.66,2.234,4.646,5.025,0,.31-.067,1.012-.067,1.012l-7.276-.036a3,3,0,0,0,3.149,2.806,5.206,5.206,0,0,0,3.044-1.142l1,1.887a6.587,6.587,0,0,1-4.245,1.488,5.4,5.4,0,0,1-5.636-5.547A5.21,5.21,0,0,1,113.181,9.633Zm2,4.227a2.035,2.035,0,0,0-2.077-2.2,2.455,2.455,0,0,0-2.533,2.178l4.61.023Z",
    transform: "translate(-59.031 -5.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M9.816,8.354,7.922,10.228a16.308,16.308,0,0,1,2.935.194,5.945,5.945,0,0,1-2.338,2,3.575,3.575,0,0,1-2.641-.057A4.823,4.823,0,0,1,2.81,8.373a6.963,6.963,0,0,1-.073-1.022,5.774,5.774,0,0,1,.172-1.3.041.041,0,0,1,0-.01,4.589,4.589,0,0,1,4.416-3.6,6.672,6.672,0,0,1,4.82,1.815l1.665-1.649A8.073,8.073,0,0,0,7.355,0H7.34A7.319,7.319,0,0,0,.149,6.021l0,.011A7.8,7.8,0,0,0,0,7.42,9.015,9.015,0,0,0,.052,8.426h0a7.153,7.153,0,0,0,7.19,6.737c1.116.068,3.33-.416,5.287-2.947a16.039,16.039,0,0,1,.165,2.87v.036l1.9-1.886.024-4.857-4.8-.024Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GB_GenieAsk_Icon",
    transform: "translate(3431.331 -388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M22.033,25.612a.815.815,0,0,1-.381-.1L13.52,21.18H4.086a2.433,2.433,0,0,1-2.43-2.43V6.3a2.433,2.433,0,0,1,2.43-2.43H23.359a2.433,2.433,0,0,1,2.43,2.43V18.749a2.433,2.433,0,0,1-2.43,2.43h-.516V24.8a.812.812,0,0,1-.81.811ZM4.086,5.492a.811.811,0,0,0-.81.81V18.749a.811.811,0,0,0,.81.81h9.637a.817.817,0,0,1,.381.1l7.119,3.8V20.369a.81.81,0,0,1,.81-.81h1.326a.811.811,0,0,0,.81-.81V6.3a.811.811,0,0,0-.81-.81Z",
    transform: "translate(-1.656 -3.872)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_316",
    "data-name": "Ellipse 316",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(4.536 7.063)",
    fill: "#f7941e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_317",
    "data-name": "Ellipse 317",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(10.513 7.063)",
    fill: "#f7941e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_318",
    "data-name": "Ellipse 318",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(16.514 7.063)",
    fill: "#f7941e"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenieAsk);
export default __webpack_public_path__ + "static/media/GenieAsk.46fb6efd4d1eda738e9e4e9ab1ba5538.svg";
export { ForwardRef as ReactComponent };